import { CONSORS_RESIDENCE_PERMIT_TYPES } from 'cpool-constants';
import { z } from 'zod';

export const schemaConsorsResidencePermitType = z.nativeEnum(CONSORS_RESIDENCE_PERMIT_TYPES);
